<template>
	<span>
		<a href="javascript:void(0)"  v-if="canGoBack" @click="goBack" class="uk-text-small uk-text-muted">
			<span uk-icon="chevron-left"></span>
			vorige pagina
		</a>
	</span>
</template>

<script>
export default {
	data() {
		return {
			canGoBack: window.history.length > 1
		};
	},
	methods: {
		goBack() {
			window.history.back();
		}
	}
};
</script>
